module.exports = __webpack_public_path__ + "img/iphone-map-POLAND-pl.1e46e802.png";